import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MemberService } from '@app/services/member.service';
import { forkJoin, Subscription } from 'rxjs';
import { AdminService } from '@app/services/admin/admin.service';
import { FeeService } from '@app/services/fees/fee.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-admin-recalculate-fees-member',
  templateUrl: './admin-recalculate-fees-member.component.html'
})
export class AdminRecalculateFeesMemberComponent implements OnDestroy, OnInit {
  
  member;
  primaryinstitution;
  result;
  subscriptions: Subscription[] = [];
  imageToShow: any;
  imagewidth;
  imageheight;
  message;
  form;

  constructor(
    private fb: FormBuilder,
    private memberService: MemberService,
    private adminService: AdminService,
    public feeService: FeeService,
    public confirmationService: ConfirmationService) { }

    ngOnInit(): void {
      this.form = this.fb.group({
        memberId: ['', null],
        institutionId: ['', null]
      });
    }
    
  confirmRemoveMember(): void {
     this.confirmationService.confirm({
      header: 'Information',
      message: 'Är du säker på att du vill uppdatera aktuell medlems avgifter?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.adminService.DeleteAndUpdateMemberFee(+this.form.get('memberId').value).subscribe(resp => {
          if (resp) {
            this.member = '';
            this.message = 'Uppdaterade medlemsavgifter';
          } else {
            this.message = 'Systemet lyckades inte uppdatera medlemsavgifter.';
          }
        });
      },
      reject: () => {
      }
    });
  }

  confirmRecalculateAllMemberFees(): void {
     this.confirmationService.confirm({
      header: 'Information',
      message: 'Är du säker på att du vill uppdatera avgifterna för alla medlemmar tillhörande vald institution?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        
        this.adminService.DeleteAndUpdateAllMemberFees(+this.form.get('institutionId').value).subscribe(resp => {
          if (resp) {
            this.member = '';
            this.message = 'Uppdaterade medlemsavgifter';
          } else {
            this.message = 'Systemet lyckades inte uppdatera medlemsavgifter.';
          }
        });
      },
      reject: () => {
      }
    });
  }

  getMemberInfo() {
    let memberid = this.form.get('memberId').value;
    this.memberService.getMemberById(+memberid).subscribe(response => {
      if (response) {
        this.member = response;
      }
    });
    this.memberService.getMemberPrimaryInstitution(+memberid).subscribe(response => {
      if (response) {
        this.primaryinstitution = response;
      }
    });

    let memberinfo = this.memberService.getMemberById(+memberid);
    let memberprimaryinstitution = this.memberService.getMemberPrimaryInstitution(+memberid);
    this.subscriptions.push(forkJoin([
      memberinfo,
      memberprimaryinstitution
    ]).subscribe(response => {
      this.member = response[0];
      this.primaryinstitution = response[1];
      this.getImageFromService(this.member.id);
    }));

  }



  getImageFromService(memberid: any) {
    this.memberService.GetMemberImageThumbnail(memberid).subscribe(data => {
      if (data !== null) {
        this.createImageFromBlob(data);
      } else {
        this.imageToShow = null;
      }
    }, error => {
      this.imageToShow = null;
    });
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageToShow = reader.result;
      if (this.imageToShow) {
        this.getSize(this.imageToShow);
      }
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  getSize(imgdata: any) {
    const image = document.createElement('img');
    const self = this;
    image.addEventListener('load', function () {
      self.imagewidth = image.width / 2;
      self.imageheight = image.height;
    });
    image.src = imgdata;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }
}


